module.exports = __webpack_public_path__ + "img/register.bc0deb61.svg";